// Hamburger events
$(document).ready(() => {
    $(".navbar__icon").click(function () {
        $('.nav').toggleClass("opened");
        $('.header__icon').toggleClass("opened");
        $('.navbar').toggleClass("opened");
        $('body').toggleClass("overflow-hidden");
    });
    $('.nav__item-title').on('click', function() {
        if ($(window).width() < 1280) {
            $(this).siblings('.sub-menu').toggleClass('open');
        }
    });
});
// Hamburger events end

// Scroll
$(document).ready(function () {
  'use strict';

  var navbar = $('.navbar');
  var lastScrollTop = 0;

  function handleScroll() {
    var scrollTop = $(window).scrollTop();
    var navbarHeight = navbar.outerHeight();

    // Toggle background class
    if (scrollTop >= 80) {
      navbar.addClass('bg-white');
    } else {
      navbar.removeClass('bg-white');
      navbar.removeClass('navbar-hidden');
    }

    // Show/hide navbar based on scroll direction
    if (scrollTop > lastScrollTop && scrollTop > navbarHeight * 2) {
      // Scrolling down
      navbar.addClass('navbar-hidden').removeClass('bg-white');
    } else if (scrollTop < lastScrollTop && scrollTop > navbarHeight) {
      // Scrolling up
      navbar.removeClass('navbar-hidden').addClass('bg-white');
    }

    lastScrollTop = scrollTop;
  }

  $(window).on('scroll resize load', handleScroll);

  // ✅ Run once on page load
  handleScroll();
});
// Scroll end

// Menu open
$(document).ready(function () {
    // Toggle nav box on title click
    $(".nav__item-title").on("click", function (e) {
        e.stopPropagation(); // Stop click from bubbling up

        const $title = $(this);
        const $box = $title.siblings(".nav__box");
        const isOpen = $title.hasClass("is-open");

        // Close all
        $(".nav__item-title").removeClass("is-open");
        $(".nav__box").removeClass("is-open");

        // Open if it wasn’t already open
        if (!isOpen) {
            $title.addClass("is-open");
            $box.addClass("is-open");
        }
    });

    // Stop click inside nav__box from bubbling up
    $(".nav__box").on("click", function (e) {
        e.stopPropagation();
    });

    // Click anywhere else = close all
    $(document).on("click", function () {
        $(".nav__item-title").removeClass("is-open");
        $(".nav__box").removeClass("is-open");
    });
});


// Menu open end


// Menu open
$(document).ready(function () {
    // If window width is less than 1279, remove active states on load
    if ($(window).width() < 1279) {
        $('.nvService__list').removeClass('opened');
        $('.nvService__list .nvService-subtitle').removeClass('opened');
        $('.nvService__list .nvService__links').removeClass('opened');

    }

    // Click behavior
    $('.nvService__list').on('click', function () {
        // If already opened, do nothing
        if ($(this).hasClass('opened')) return;

        // Close all
        $('.nvService__list').removeClass('opened');
        $('.nvService__list .nvService-subtitle').removeClass('opened');
        $('.nvService__list .nvService__links').removeClass('opened');

        // Open clicked
        $(this).addClass('opened');
        $(this).find('.nvService-subtitle').addClass('opened');
        $(this).find('.nvService__links').addClass('opened');
    });

    // Click on a separate .nvService-subtitle
    $('.nvService-subtitle').on('click', function () {
        const subtitleText = $(this).text().trim();

        // Find matching .nvService__list with the same subtitle text
        const targetList = $('.nvService__list').filter(function () {
            return $(this).find('.nvService-subtitle').text().trim() === subtitleText;
        });

        if (targetList.length > 0) {
            $('.nvService-subtitle').removeClass('is-open');
            $('.nvService__list').removeClass('opened');
            $('.nvService__list .nvService-subtitle').removeClass('opened');
            $('.nvService__list .nvService__links').removeClass('opened');

            targetList.addClass('opened');
            targetList.find('.nvService-subtitle').addClass('opened');
            targetList.find('.nvService__links').addClass('opened');
            $(this).addClass('is-open');
        }
    });

});
